<!-- Navbar -->
<div class="toolbar" role="banner">
  <img width="45" height="45" alt="Logo" src="../../../../assets/icons/logo.png" />
  <h4>{{'ramConsulting'|translate}}</h4>
</div>

<br><br>

<!-- Content -->
<spinner></spinner>
<div class="content" role="main" *ngIf="!isSpinnerActivated && formGroup">
  <div class="row">
    <div class="col-md-8 text-center">
      <h4 class="title"></h4>
      <br>
      <img src="../../../assets/img/img_home.png" style="width: 60%">
    </div>
    <div class="col-md-4" id="login">
      <div class="card mb-2">
        <div class="card-header text-center py-4">
          <b>{{'login' | translate}}</b>
        </div>
        <div class="card-body">
          <form [formGroup]="formGroup">
            <form-row>
              <ng-template formRowTemplate="content">
                <form-input-text [control]="formGroup.controls['utente']" [label]="'utente'|translate"
                  [placeholder]="'tuoNomeUtente'|translate">
                </form-input-text>
              </ng-template>
            </form-row>
            <form-row>
              <ng-template formRowTemplate="content">
                <form-input-password [control]="formGroup.controls['password']" [label]="'password'|translate"
                  [placeholder]="'tuaPassword'|translate">
                </form-input-password>
              </ng-template>
            </form-row>

            <div class="d-flex w-100 justify-content-center">
              <button type="button" class="btn btn-link"
                (click)="openPasswordDimenticataDialog()">{{'passwordDimenticata' | translate}}</button>
            </div>

            <hr>

            <form-buttonbar [formInvalid]="formGroup.invalid" [confirmLabel]="'accedi' | translate"
              confirmIconClass="fas fa-sign-in-alt" (submit)="login()">
            </form-buttonbar>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>

<password-dimenticata-dialog #passwordDimenticataDialog></password-dimenticata-dialog>
<password-scaduta-dialog #passwordScadutaDialog></password-scaduta-dialog>